import { useSelector } from 'react-redux';
import { getGtkmShowingErrorModal } from '../store/gtkm/selector';
import { getPreviousStep } from '../store/flow/selectors';
import { Step } from 'signup-constants/Step';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { isEndpointStatusError } from '../store/http-responses/selectors';
import { EndpointKey } from '../http/EndpointKey';
import { getShowBreezeErrorModal } from '../store/flow/selectors';
import { useCurrentStep } from './useCurrentStep';
export const useShowErrorModal = () => {
  const showGTKMErrorModal = useSelector(getGtkmShowingErrorModal);
  const previousStep = useSelector(getPreviousStep);
  const {
    currentStep
  } = useCurrentStep();
  const breezeEndpointError = useSelector(isEndpointStatusError(EndpointKey.BreezeCompanyInfo));
  const showBreezeErrorModal = useSelector(getShowBreezeErrorModal);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ172Variant
  } = useExperiment(ExperimentKeys.ACQ0172, TrackWhen.never);
  const isAssignedToACQ172VariantB = isAssignedToACQ172Variant(ExperimentParameterGroup.Variant_B);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantC = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_C);
  const isAssignedToACQ173VariantAorC = isAssignedToACQ173VariantA || isAssignedToACQ173VariantC;
  const isPreviousStepCompanyDomain = previousStep === Step.CompanyDomain;
  const renderBreezeErrorModal = isAssignedToACQ172VariantB && currentStep === Step.Industry && breezeEndpointError && showBreezeErrorModal;
  const renderGTKMErrorModal = isAssignedToACQ173VariantAorC && isPreviousStepCompanyDomain && showGTKMErrorModal;
  return {
    showErrorModal: renderBreezeErrorModal || renderGTKMErrorModal
  };
};